var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-upload',{staticClass:"avatar-uploader",attrs:{"show-file-list":false,"before-upload":_vm.beforeAvatarUpload,"action":""}},[(_vm.imageUrl)?_c('el-image',{staticClass:"avatar",attrs:{"src":_vm.imageUrl,"fit":"fit"}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }